import React from 'react';
import { Clock, MapPin } from 'lucide-react';
import { businessInfo } from '../mock';

const StoreInfo = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12">
            {/* Store hours */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8 flex items-center gap-3">
                <Clock className="w-8 h-8 text-red-600" />
                Store Hours
              </h2>
              <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                {businessInfo.hours.map((hour, index) => (
                  <div key={index} className="flex justify-between items-center border-b border-gray-200 pb-3 last:border-b-0">
                    <span className="font-medium text-gray-900">{hour.day}</span>
                    <span className={`${hour.hours === 'Closed' ? 'text-red-600' : 'text-gray-600'}`}>
                      {hour.hours}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Store image and info */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Our Store</h2>
              <div className="rounded-xl overflow-hidden shadow-lg mb-6">
                <img 
                  src="https://lirp.cdn-website.com/1d57ed00/dms3rep/multi/opt/Streetsville+Eyecare+Mississauga+Store8-1920w.jpg" 
                  alt="Store interior" 
                  className="w-full h-80 object-cover"
                />
              </div>
              <div className="bg-gray-50 rounded-xl p-6">
                <p className="text-gray-700 mb-4">
                  Our newly renovated store is as unique as our frames! Our well lit store is the perfect setting to view and sample your new frames.
                </p>
                <p className="text-gray-700 mb-6">
                  We have an on-site optometrist, optician and dozens of designer frames in stock ready for you to try on!
                </p>
                <a 
                  href="https://www.google.ca/maps/place/Streetsville+EyeCare/@43.58243,-79.7264322,16z"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-red-600 text-white px-6 py-3 rounded-md hover:bg-red-700 transition-colors font-medium"
                >
                  <MapPin className="w-5 h-5" />
                  Get Directions To Our Store
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StoreInfo;
